import * as React from 'react';

import { FavoriteButtonMobileContainer } from '../../FavoriteButton';
import { MotivationPopupMobileContainer } from '../../MotivationPopup';

export const FavoriteButtonMobileWithMotivation: React.FC = () => {
  return (
    <>
      <FavoriteButtonMobileContainer />
      <MotivationPopupMobileContainer />
    </>
  );
};
